import { render, staticRenderFns } from "./OrdersTableEsSuperAgent.vue?vue&type=template&id=98a1f230&scoped=true"
import script from "./OrdersTableEsSuperAgent.vue?vue&type=script&lang=js"
export * from "./OrdersTableEsSuperAgent.vue?vue&type=script&lang=js"
import style0 from "./OrdersTableEsSuperAgent.vue?vue&type=style&index=0&id=98a1f230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a1f230",
  null
  
)

export default component.exports